import React from "react";

const Confirmation = () => {
  return (
    <div className="flex flex-col items-start my-12 gap-4">
      <p className="text-[20px] font-bold text-center">
        Thank you for wanting to partner with TrueKeepers, a member of our team
        will reach out soon.
      </p>
      <button
        onClick={() => {}}
        type="button"
        className="bg-[#213874] rounded-md text-white w-full p-2"
      >
        Continue
      </button>
    </div>
  );
};

export default Confirmation;
